/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgDuplicateNamespace = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M10 10H8V8h2zM4 4H2V2h2zm18 6h-2V8h2zm-6-6h-2V2h2zm2 6h-2V8h2zm-6-6h-2V2h2zm6 18h-2v-2h2zm-4 0h-2v-2h2zm-4 0H8v-2h2zm-6-6H2v-2h2zm6 2H8v-2h2zm-6-6H2v-2h2zm6 2H8v-2h2zM4 8H2V6h2zm18 6h-2v-2h2zm0 4h-2v-2h2zm0 4h-2v-2h2zm-8-12h-2V8h2zM8 4H6V2h2z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgDuplicateNamespace as DuplicateNamespace };
